import * as React from 'react'
import {
  IonButton,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonModal,
  IonPage,
  IonRow,
  useIonAlert,
} from '@ionic/react'
import { filter } from 'ionicons/icons'

import { useBroadcastActions } from '../../../marketing/broadcasts/broadcast-store'
import { useAccount, useUser } from '../../../contexts/authContext'
import { useAllSubscribedClients } from '../../../hooks/clients/queries'
import { useInfiniteList } from '../../../hooks/use-infinite-list'
import { useFormatNumber } from '../../../hooks/use-format-number'
import ClientItem, {
  ClientItemSkeleton,
} from '../../../components/client/client-item'
import PullClientsModal from '../../../components/client/pull-clients-modal'
import AdminHeader from '../../../components/header/admin-header'
import type { FiltersFromForm } from '../../../utils/compose-search-filters'

function AdminPullBroadcast() {
  const [isSearchModalOpen, setIsSearchModalOpen] = React.useState(true)
  const [filters, setFilters] = React.useState<FiltersFromForm>({})

  const account = useAccount()
  const user = useUser()

  const [presentAlert] = useIonAlert()

  const formatNumber = useFormatNumber()
  const { initializeBroadcast } = useBroadcastActions()
  const { infiniteListCount, doInfiniteStuff } = useInfiniteList()

  const adminClientSearchQuery = useAllSubscribedClients(filters)

  return (
    <IonPage>
      <IonHeader>
        <IonHeader>
          <AdminHeader
            backRef="/tabs/admin/broadcasts"
            title="Pull Your Client List"
          />
        </IonHeader>
      </IonHeader>
      <IonContent>
        <div className="ion-margin-top">
          <IonGrid
            style={{ '--ion-grid-padding': 0 }}
            className="ion-padding-horizontal"
          >
            <IonRow className="ion-nowrap ion-align-items-center">
              <IonCol className="flex-full">
                <div className="flex items-center gap-x-2">
                  <IonButton
                    disabled={!Boolean(adminClientSearchQuery.data?.length)}
                    size="small"
                    color="yellow"
                    fill="solid"
                    routerLink="/tabs/admin/broadcasts/create"
                    onClick={() => {
                      adminClientSearchQuery.data
                        ? initializeBroadcast({
                            clients: adminClientSearchQuery.data,
                            account,
                            user,
                            type: 'admin',
                          })
                        : presentAlert(
                            'There are no clients to broadcast to. Please try the search again.'
                          )
                    }}
                  >
                    Create Broadcast
                  </IonButton>
                  <h2 className="text-ion-color-yellow ml-2">
                    {formatNumber(adminClientSearchQuery.data?.length)} Client
                    {adminClientSearchQuery.data?.length === 1 ? '' : 's'}
                  </h2>
                </div>
              </IonCol>
              <IonCol>
                <IonButton
                  disabled={adminClientSearchQuery.isLoading}
                  onClick={() => setIsSearchModalOpen(true)}
                  size="small"
                  color="secondary"
                >
                  Filter
                  <IonIcon slot="end" icon={filter} />
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </div>

        {adminClientSearchQuery.isLoading ? (
          Array(10)
            .fill(null)
            .map((_item, idx) => <ClientItemSkeleton key={idx} />)
        ) : adminClientSearchQuery.data ? (
          <>
            {adminClientSearchQuery.data
              .slice(0, infiniteListCount)
              .map((client) => (
                <ClientItem key={client.objectId} client={client} />
              ))}
            <IonInfiniteScroll
              onIonInfinite={doInfiniteStuff}
              disabled={infiniteListCount >= adminClientSearchQuery.data.length}
            >
              <IonInfiniteScrollContent loadingSpinner="bubbles" />
            </IonInfiniteScroll>
          </>
        ) : null}
      </IonContent>
      <IonModal
        isOpen={isSearchModalOpen}
        onDidDismiss={() => setIsSearchModalOpen(false)}
      >
        <PullClientsModal
          isAdmin
          filters={filters}
          onSearch={(searchFilters) => {
            setFilters(searchFilters)
            setIsSearchModalOpen(false)
          }}
          onCancel={() => setIsSearchModalOpen(false)}
        />
      </IonModal>
    </IonPage>
  )
}

export default AdminPullBroadcast
